export default __webpack_public_path__ + "static/media/WallNotification_Curacao-Picture.483e06f0.png";